import React from "react";
import { connect } from "react-redux";
import {
  Button,
  ButtonToolbar,
  Col,
  Glyphicon,
  Grid,
  Row,
} from "react-bootstrap";
import AddFirmwareElement from "./add-firmware-element";
import { Panel } from "../../Panel";
import moment from "moment";

class AddFirmware extends React.Component {
  constructor(props) {
    super(props);

    const productId =
      this.props.configurations &&
      this.props.configurations.find(
        (config) => config.fieldName === "unit_family"
      ).value;

    this.state = {
      firmwares: this.props.firmwares,
      configurations: this.props.configurations,
      unitFamily: productId ? parseInt(productId) : 47, //MIXIT default
    };

    this.onBack = this.onBack.bind(this);
  }

  onFirmwareRemoved(item, path) {
    let updatedFirmware = this.setValuesToFields(
      this.state.firmwares,
      "path",
      path,
      item
    );

    //update firmwares
    this.setState({ firmwares: updatedFirmware });
  }

  onFirmwareSelected(item, path) {
    let updatedFirmware = this.setValuesToFields(
      this.state.firmwares,
      "path",
      path,
      item
    );

    //update firmwares
    this.setState({ firmwares: updatedFirmware });
  }

  setValuesToFields(array, field, value, selectedItem) {
    return array.map((item) => {
      if (item[field] !== value) {
        return item;
      }

      return {
        ...item,
        ...{
          fileId: selectedItem.id,
          fileName: selectedItem.fileName,
          path: value,
          fileSize: selectedItem.fileSize,
          fileType: selectedItem.fileTypeValue,
          newSWSAPNumber: selectedItem.newSWSAPNumber,
          hasSecurityPatch: selectedItem.hasSecurityPatch,
          sha256: selectedItem.sha256,
          sequence: 0,
          hasChanged: selectedItem.hasChanged,
          elementStatus: selectedItem.elementStatus,
          isDeleted: selectedItem.isDeleted,
          isRequired: false,
          DateUploaded: moment(selectedItem.dateUploaded).unix(),
        },
      };
    });
  }

  onBack() {
    this.props.onBack(this.state.firmwares);
  }

  onNext() {
    this.props.onNext(this.state.firmwares);
  }

  getLabel = (path) => {
    var software = this.state.configurations.find(
      (p) => p.path === path && p.fieldName === "sw_sap_no_ver"
    );
    var hardware = this.state.configurations.find(
      (p) => p.path === path && p.fieldName === "hw_sap_no_rev"
    );

    var softwareLabel = "[No Value]";
    var hardwareLabel = "[No Value]";

    if (!(software.displayValue === null || software.displayValue === "")) {
      softwareLabel = software.displayValue;
    }

    if (!(hardware.displayValue === null || hardware.displayValue === "")) {
      hardwareLabel = hardware.displayValue;
    }

    return `${softwareLabel} / ${hardwareLabel}`;
  };

  render() {
    return (
      <Grid fluid>
        <h1>Select Firmware for {this.props.configName}</h1>
        <Row>
          <Col sm={12}>
            <Panel>
              <div className="panel-body">
                {this.state.firmwares.map((firmware) => (
                  <AddFirmwareElement
                    label={this.getLabel(firmware["path"])}
                    firmware={firmware}
                    path={firmware["path"]}
                    onFirmwareSelected={this.onFirmwareSelected.bind(this)}
                    onFirmwareRemoved={this.onFirmwareRemoved.bind(this)}
                    unitFamily={this.state.unitFamily}
                  />
                ))}
                <ButtonToolbar className="pull-right">
                  <Button
                    bsStyle="primary"
                    id="btnBack"
                    onClick={() => {
                      this.onBack();
                    }}
                  >
                    <Glyphicon glyph="arrow-left" /> Back
                  </Button>
                  <Button
                    bsStyle="primary"
                    id="btnNext"
                    onClick={() => {
                      this.onNext();
                    }}
                  >
                    Next <Glyphicon glyph="arrow-right" />
                  </Button>
                </ButtonToolbar>
              </div>
            </Panel>
          </Col>
        </Row>
      </Grid>
    );
  }
}

export default connect()(AddFirmware);
